import { render } from "./CoachForm.vue?vue&type=template&id=1d9571bb&scoped=true"
import script from "./CoachForm.vue?vue&type=script&lang=js"
export * from "./CoachForm.vue?vue&type=script&lang=js"

import "./CoachForm.vue?vue&type=style&index=0&id=1d9571bb&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9571bb"]])

export default __exports__